/** Procurement categories from the homepage workflow picker, including saved legacy paths. */
export const WORKFLOW_CATEGORY_TYPES: Record<string, readonly string[]> = {
    commodities: ['market_research', 'clause_logic', 'gpc', 'post_award_actions'],
    construction: ['one_time_construction', 'sow_verification', 'wage_determination', 'pnm', 'fopr', 'clause_logic', 'construction_sow_generation', 'post_award_actions'],
    services: ['services', 'complex_services', 'services_combo', 'clause_logic', 'services_pws_generation', 'post_award_actions'],
    dcma: ['dcma_pbp', 'dcma_crr'],
    other_transactions: ['other_transactions'],
};
export const WORKFLOW_CATEGORY_OPTIONS = [
    { value: 'commodities', label: 'Commodities' },
    { value: 'construction', label: 'Construction' },
    { value: 'services', label: 'Services' },
    { value: 'dcma', label: 'DCMA' },
    { value: 'other_transactions', label: 'Other Transactions' },
];
export function workflowCategoriesForTypes(types: string[]): string[] {
    return WORKFLOW_CATEGORY_OPTIONS.filter(category => types.some(type => WORKFLOW_CATEGORY_TYPES[category.value].includes(type))).map(category => category.value);
}
